// Index.js is responsible for pushing the whole Application into the Root element in Index.html.

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import configureStore from './store/configure-store';
import Controller from './controller.jsx';

// Here we configure the store (Global state manager)
const store = configureStore();

// This is the render function that basically gets pushed into the Root HTML element
ReactDOM.render(
  <Provider store={store}>
    <Controller />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./client/app.js